<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>fa-user-times</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Close Customer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout>
                <v-select
                  :items="closeReasons"
                  item-text="reason"
                  item-value="value"
                  dense
                  placeholder="Reason for Closing"
                  v-model="closeReason"
                >
                </v-select>
                <v-spacer></v-spacer>
                <v-btn :disabled="closeReason === null" color="success" @click="closeCustomer">Close</v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'close-customer-dialog',
  props: ['show', 'customer'],
  data: () => ({
    closeReasons: [
      { value: "Platform - Couldn't find SME finance", reason: "Platform - Couldn't find SME finance" },
      { value: 'Platform - Successful funding', reason: 'Platform - Successful funding' },
      { value: 'Platform - Never made contact', reason: 'Platform - Never made contact' },
      { value: 'Platform - None responsive', reason: 'Platform - None responsive' },
      { value: 'Platform - SME no longer eligible', reason: 'Platform - SME no longer eligible' },
      { value: 'SME - No longer require finance', reason: 'SME - No longer require finance' },
      { value: 'SME - Found/sought finance elsewhere', reason: 'SME - Found/sought finance elsewhere' },
      { value: 'Bank - Unreferred SME', reason: 'Bank - Unreferred SME' },
      { value: 'Platform - Test data', reason: 'Platform - Test data' },
      { value: 'Platform - Duplicate data', reason: 'Platform - Duplicate data' },
      { value: 'Platform – Invalid contact data', reason: 'Platform – Invalid contact data' }
    ],
    closeReason: null
  }),
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['updateCustomer', 'addNotification']),
    closeDialog() {
      this.dialog = false;
    },
    closeCustomer() {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          closed: true,
          reason_for_closing: this.closeReason
        }
      }).then(() => {
        this.addNotification({
          text: `${this.customer.name} closed`
        });
        this.dialog = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
